import React from 'react'

import _ from 'lodash'
import dateFormat from 'dateformat'

// Import Scss
import './ChatroomList.scss'

const chatroomItem = (props) => {

  const {chatroom} = props
  const lastMessage = _.last(chatroom.findme_messages)
  const time = dateFormat(lastMessage.created_at, "yyyy-mm-dd HH:MM")
  return(
    <div className="chatroom-item d-flex"
      onClick={() => props.onChatroomItemClick(chatroom.id)}
    >
      <div className="chatroom__avatar">
        <img src={chatroom.avatar} alt="Avatar" />
      </div>
      <div className="chatroom__info">
        <p className="info__time">{time}</p>
        <p className="info__name">{chatroom.name}</p>
      </div>
      <div className="chatroom__message">
        <p>{lastMessage.content}</p>
      </div>
    </div>
  )
}

export default chatroomItem



// WEBPACK FOOTER //
// ./src/routes/support/components/ChatroomItem.js